import { Link } from "react-router-dom";
import { AnimatedSection } from "@/components/common/AnimatedSection";
import { Plane, Globe, Users, Map, Ship, ArrowRight } from "lucide-react";

const services = [
  {
    icon: Globe,
    title: "International Flight Booking",
    desc: "Expert assistance for complex international routes, family travel, and hard-to-book itineraries.",
    path: "/international-flight-booking",
  },
  {
    icon: Plane,
    title: "Flights to India from USA",
    desc: "Specialists in US-to-India travel — diaspora families, students, and flexible-date travelers.",
    path: "/flights-to-india-from-usa",
  },
  {
    icon: Plane,
    title: "Flights to Africa from USA",
    desc: "Nigeria, Ghana, Kenya, South Africa, and more — with expert routing guidance.",
    path: "/flights-to-africa-from-usa",
  },
  {
    icon: Map,
    title: "Custom Tour Packages",
    desc: "Itineraries designed around your destination, budget, and travel style — not a template.",
    path: "/custom-tour-packages",
  },
  {
    icon: Users,
    title: "Group Travel Planning",
    desc: "Flights, hotels, and logistics for families, community groups, and corporate teams.",
    path: "/group-travel-planning",
  },
  {
    icon: Ship,
    title: "Cruise Booking Assistance",
    desc: "Caribbean, Mediterranean, Alaska, and polar expeditions with full booking support.",
    path: "/cruise-booking-assistance",
  },
];

export const ServicesLinksSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-10">
            <p className="overline mb-3">Expert Services</p>
            <h2 className="heading-lg text-primary">What Tripsyfy Can Book for You</h2>
          </div>
        </AnimatedSection>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {services.map(({ icon: Icon, title, desc, path }, i) => (
            <AnimatedSection key={path} delay={i * 0.06}>
              <Link
                to={path}
                className="group bg-surface-subtle rounded-xl p-6 flex flex-col gap-4 hover:shadow-card-hover transition-shadow duration-200"
              >
                <div className="h-11 w-11 rounded-xl bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                  <Icon className="h-5 w-5 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm font-bold text-primary mb-1.5">{title}</h3>
                  <p className="text-xs text-muted-foreground leading-relaxed">{desc}</p>
                </div>
                <div className="flex items-center gap-1.5 text-xs font-semibold text-accent">
                  Learn more <ArrowRight className="h-3.5 w-3.5" />
                </div>
              </Link>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};
